import { ExportsPage } from "@/components/exports/exports-page";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/exports")({
  component: Exports,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "exports");
  },
});

function Exports() {
  return <ExportsPage />;
}
